import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const storagePlugin = store => {
  store.subscribe((mutation, state) => {
    localStorage.setItem('cart', JSON.stringify(state.cart))
  })
}

export default new Vuex.Store({
  strict: true,
  plugins: [storagePlugin],
  state: {
    // cart: localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [],
    isLogin: sessionStorage.omitoken ? 'true' : false,
    showBar: sessionStorage.getItem('showBar') !== 'false',
    tabbar: localStorage.getItem('tabId') ? JSON.parse(localStorage.getItem('tabId')) : '0',
    msg: 'sssss'
  },
  getters: {

  },
  mutations: {
    /**
     * 修改登录成功状态
     */
    changeLoginStatus (state, { status }) {
      state.isLogin = status
    },
    setShowBar (state, flag) {
      state.showBar = flag
      sessionStorage.setItem('showBar', flag)
    },
    setTabbar(state, action) {
    	state.tabbar = action
    	if (action) {
    		localStorage.getItem("tabId", action)
    	} else {
    		localStorage.removeItem("tabId")
    	}
    },
  },
  actions: {
  },
  modules: {
  }
})
